import Service from "./Service"
import organize from "../../assets/images/databases/organize.svg"
import stock from "../../assets/images/databases/stock.svg"
import time from "../../assets/images/databases/time.svg"
import sales from "../../assets/images/databases/sales.svg"
import stockmanagment from "../../assets/images/services/database.svg"
import orders from "../../assets/images/toCheck/orders.svg"
import clients from "../../assets/images/toCheck/clients.svg"
import responsive from "../../assets/images/toCheck/responsive.svg"
import other from "../../assets/images/toCheck/other.svg"
import brain from "../../assets/images/databases/brain-database-bg.svg"

const database = {
  t1: "database_title",
  header: [
    "database_header1",
    "database_header2",
    "database_header3",
  ],
  time: "database_time",
  brain: brain,
  benefits: [
    {
      img: organize,
      text: "database_benefits1",
    },
    {
      img: stock,
      text: "database_benefits2",
    },
    {
      img: sales,
      text: "database_benefits3",
    },
    {
      img: time,
      text: "database_benefits4",
    },
  ],
  info: "database_info",
  toCheck: [
    {
      id: "stock",
      text: "database_check1",
      img: stockmanagment,
    },
    {
      id: "orders",
      text: "database_check2",
      img: orders,
    },
    {
      id: "clients",
      text: "database_check3",
      img: clients,
    },
    {
      id: "responsive",
      text: "database_check4",
      img: responsive,
    },
    {
      id: "another",
      text: "database_check5",
      img: other,
    },
  ],
};

const Database = () => {
    return (
        <Service service={database}/>
    )   
}

export default Database